import React from 'react';

function conditionalValue(condition, whenTrue, whenFalse = null) {
  return condition ? whenTrue : whenFalse;
}

/**
 * Layout coordinator for the workspace footer / right-rail region.
 * The shell keeps data derivation, while this component owns placement.
 */
export default function ChatWorkspacePanelCoordinator({
  canvasPanelNode,
  canvasWorkspaceFullscreenMode,
  children,
  composerNode,
  isCompactLayout,
  showCanvasPanel,
  fullscreenComposerNode,
}) {
  return (
    <>
      <div
        style={{
          display: conditionalValue(
            [canvasWorkspaceFullscreenMode, !isCompactLayout].every(Boolean),
            'none',
            'flex'
          ),
          flex: 1,
          flexDirection: 'column',
          minHeight: 0,
        }}
      >
        {children}
        {conditionalValue([isCompactLayout, showCanvasPanel].every(Boolean), canvasPanelNode)}
        {conditionalValue(!canvasWorkspaceFullscreenMode, composerNode)}
      </div>
      {conditionalValue(!isCompactLayout, canvasPanelNode)}
      {conditionalValue(canvasWorkspaceFullscreenMode, (
        <div
          style={{
            bottom: conditionalValue(isCompactLayout, 0, 12),
            left: conditionalValue(isCompactLayout, 0, 12),
            pointerEvents: 'none',
            position: 'absolute',
            right: conditionalValue(isCompactLayout, 0, 12),
            zIndex: 6,
          }}
        >
          <div style={{ pointerEvents: 'auto' }}>
            {[fullscreenComposerNode, composerNode].find(Boolean)}
          </div>
        </div>
      ))}
    </>
  );
}
